import { render } from "./HomeInfo.vue?vue&type=template&id=3c7e3a88&ts=true"
import script from "./HomeInfo.vue?vue&type=script&lang=ts"
export * from "./HomeInfo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__